export default {
    props: {
        schemaAxes: {
            type: Function | String,
            kComposite: 'schema.axes'
        }, 
        schemaCatalogs: {
            type: Function | String,
            kComposite: 'schema.catalogs'
        }, 
        schemaCubes: {
            type: Function | String,
            kComposite: 'schema.cubes'
        }, 
        schemaCube: {
            type: Object,
            kComposite: 'schema.cube'
        }, 
        schemaData: {
            type: Function | String,
            kComposite: 'schema.data'
        }, 
        schemaDimensions: {
            type: Function | String,
            kComposite: 'schema.dimensions'
        }, 
        schemaHierarchies: {
            type: Function | String,
            kComposite: 'schema.hierarchies'
        }, 
        schemaLevels: {
            type: Function | String,
            kComposite: 'schema.levels'
        }, 
        schemaMeasures: {
            type: Function | String,
            kComposite: 'schema.measures'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/Schema.js